module.exports = __webpack_public_path__ + "img/eye-iconPreviewTest-testPage.ebf7cc03.svg";